import axios from 'axios';

export const cantonApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/canton`,
    headers: {
        'Content-Type': 'application/json'
    }
})